import cx from 'classnames';
import * as React from 'react';
import ReactDOM from 'react-dom';

import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Buttons, { ButtonsAxis } from 'components/Buttons';
import Dialog from 'components/Dialog';
import Row from 'components/Row';

import { Props as DialogProps } from 'components/Dialog';

type Props = {
  buttonText?: string;
  closeButtonText?: string;
  /** Primay button action */
  onOkay?: () => void;
} & DialogProps;

export default class AlertDialog extends React.Component<Props> {
  handleButtonClick = () => {
    const { onOkay } = this.props;

    this.handleRequestHide();

    if (onOkay) {
      onOkay();
    }
  };

  handleRequestHide = () => {
    const { onRequestHide } = this.props;
    if (onRequestHide) {
      onRequestHide();
    }
  };

  render() {
    const { buttonText, children, className, closeButtonText, size } = this.props;

    return (
      <Dialog {...this.props} size={size || 'xsmall'} className={cx('AlertDialog', className)}>
        <BoxBody>
          {children && <Row>{children}</Row>}
          <Buttons axis="y">
            <Button
              className="AlertDialog-okButton"
              eventElementName="AlertDialog-okButton"
              onClick={this.handleButtonClick}>
              {buttonText || 'OK'}
            </Button>
            {closeButtonText ? (
              <Button level="text" onClick={this.handleRequestHide}>
                {closeButtonText}
              </Button>
            ) : null}
          </Buttons>
        </BoxBody>
      </Dialog>
    );
  }
}
